import AlertCircleIcon from '@assets/icons/alert.svg';
import { AlertLevel } from '@/types';
import { createStyles, Theme } from '@/contexts/theme-context';
import { Typography } from '@usepepper/ui/atoms/typography';
import { useMemo } from 'react';
import { View } from 'react-native';

const createBannerStyles = (theme: Theme) => ({
  backgroundColor: {
    [AlertLevel.Warning]: theme.sk.color.bg.warning,
    [AlertLevel.Negative]: theme.sk.color.bg.error,
    [AlertLevel.Info]: theme.sk.color.bg.blue,
    [AlertLevel.Positive]: theme.sk.color.bg.success,
  },
  color: {
    [AlertLevel.Warning]: theme.sk.color.text.warning,
    [AlertLevel.Negative]: theme.sk.color.text.error,
    [AlertLevel.Info]: theme.sk.color.text.blue,
    [AlertLevel.Positive]: theme.sk.color.text.success,
  },
  icon: {
    [AlertLevel.Warning]: theme.sk.color.icon.warning.primary,
    [AlertLevel.Negative]: theme.sk.color.icon.negative.primary,
    [AlertLevel.Info]: theme.sk.color.icon.blue,
    [AlertLevel.Positive]: theme.sk.color.icon.positive.primary,
  },
});

interface ValidationBannerProps {
  level: AlertLevel;
  message: string;
}

export const ValidationBanner: React.FC<ValidationBannerProps> = ({
  level,
  message,
}) => {
  const [styles, theme] = useStyles();
  const { backgroundColor, color, icon } = useMemo(
    () => createBannerStyles(theme),
    [theme],
  );

  return (
    <View
      style={[styles.container, { backgroundColor: backgroundColor[level] }]}
    >
      <View style={styles.iconContainer}>
        <AlertCircleIcon fill={icon[level]} height={16} width={16} />
      </View>
      <Typography color={color[level]} variant="paragraph-md">
        {message}
      </Typography>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    borderRadius: theme.sk.radii.radiusMedium,
    display: 'flex',
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceSmall,
    paddingHorizontal: theme.sk.spacing.spaceMedium,
    paddingVertical: theme.sk.spacing.spaceSMedium,
  },
  iconContainer: {
    paddingTop: 2,
  },
}));
